import styled from 'styled-components'
import { em } from 'polished'
import { Icon, Dropdown } from '@binance-chain/honeycomb'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.honeycomb.color.text.normal};
  line-height: 16px;
  cursor: pointer;
  white-space: nowrap;
  height: 100%;
  width: 100%;

  a {
    color: ${({ theme }) => theme.honeycomb.color.text.normal};
    height: 100%;
    width: 100%;
    display: flex;
    text-align: left;
    align-items: center;
    &:hover {
      color: ${({ theme }) => theme.honeycomb.color.text.primary};
    }
  }
  svg {
    transform: translateY(2px);
  }
`

export const Profile = styled.div`
  margin-top: ${({ theme }) => em(theme.honeycomb.size.tiny)};
  margin-bottom: ${({ theme }) => em(theme.honeycomb.size.tiny)};
  background: ${({ theme }) => theme.honeycomb.color.secondary.normal};
  border-radius: ${({ theme }) => em(theme.honeycomb.radius.normal)};
  padding: ${({ theme }) => em(theme.honeycomb.size.micro)}
    ${({ theme }) => em(theme.honeycomb.size.small)};
  height: ${({ theme }) => theme.honeycomb.size.huge}px;
  display: flex;
  flex-direction: column;
  min-width: ${em(130)};
  align-items: flex-start;
  transition: color 0.3s ease;
  color: ${({ theme }) => theme.honeycomb.color.text.normal};
  cursor: pointer;
  justify-content: center;
  svg {
    transition: color 0.3s ease;
    fill: ${({ theme }) => theme.honeycomb.color.primary.normal};
  }
`

export const ProfileInner = styled.div`
  align-items: center;
  display: flex;
  font-size: ${({ theme }) => em(theme.honeycomb.size.normal, theme.honeycomb.size.reduced)};
  font-weight: 500;
  line-height: ${({ theme }) => em(theme.honeycomb.size.increased)};
`

export const ProfileInnerText = styled.div`
  display: flex;
  font-size: ${({ theme }) => em(theme.honeycomb.size.reduced, theme.honeycomb.size.reduced)};
  line-height: ${({ theme }) => em(theme.honeycomb.size.normal)};
  @media (max-width: ${em(767)}) {
    font-size: ${({ theme }) => em(10, theme.honeycomb.size.reduced)};
  }
`

export const Address = styled.div`
  display: flex;
  padding-left: ${({ theme }) => em(theme.honeycomb.size.micro)};
  font-size: ${({ theme }) => em(theme.honeycomb.size.reduced, theme.honeycomb.size.reduced)};
`

export const HighlightedAddress = styled(Address)`
  color: ${({ theme }) => theme.honeycomb.color.text.primary};
`

export const BinanceWalletIcon = styled(Icon.BinanceChain)`
  font-size: ${({ theme }) => em(theme.honeycomb.size.reduced, theme.honeycomb.size.reduced)};
`

export const WalletConnectColorIcon = styled(Icon.WalletConnectColor)`
  font-size: ${({ theme }) => em(20, theme.honeycomb.size.reduced)};
`

export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 4em;

  > a {
    border-radius: 0.5em;
  }
`

export const AddressForCopy = styled.div`
  font-size: ${({ theme }) => em(theme.honeycomb.size.normal)};
  display: flex;
`

export const AddressLabel = styled.div`
  color: ${({ theme }) => theme.honeycomb.color.text.masked};
  display: flex;
  font-size: ${({ theme }) => em(theme.honeycomb.size.small)};
  margin-bottom: ${({ theme }) => em(theme.honeycomb.size.micro)};
`

export const AddressContainer = styled.div`
  display: flex;
  line-height: ${em(18)};
  justify-content: space-between;
  align-items: center;
`

export const AddressOperations = styled.div`
  display: flex;
  font-size: ${({ theme }) => em(theme.honeycomb.size.small)};
`

export const DropdownItem = styled(Dropdown.Item)`
  min-width: ${em(226)};
  padding: 0 ${({ theme }) => em(theme.honeycomb.size.normal, theme.honeycomb.size.reduced)};
`

export const MainDropdownItem = styled(DropdownItem)`
  height: 4em;
`
